import { ChangeEvent, FunctionComponent, InputHTMLAttributes, TextareaHTMLAttributes } from 'react';

// Components
import { useFormikContext } from 'formik';

// Utilities
import classnames from 'classnames';

// Styles
import styles from './Field.module.scss';

interface FieldProps {
    name?: string;
    className?: string;
}

const Field: FunctionComponent<InputHTMLAttributes<HTMLInputElement> & FieldProps> = ({ className, ...props }) => {
    const { values, errors, setFieldValue } = useFormikContext();

    const handleChangeValue = (event: ChangeEvent<HTMLInputElement>) => {
        setFieldValue(props.name, event.target.value, !!errors[props.name]);
    };

    const wrapperClassName = classnames([styles.wrapper, className]);

    return (
        <div className={wrapperClassName}>
            <input {...props} value={values[props.name]} className={styles.input} autoComplete="off" onChange={handleChangeValue} />
            {errors[props.name] && <span className={styles.error}>{errors[props.name]}</span>}
        </div>
    );
};

Field.defaultProps = {
    className: '',
};

export const FieldArea: FunctionComponent<TextareaHTMLAttributes<HTMLTextAreaElement> & FieldProps> = ({ className, ...props }) => {
    const { values, errors, setFieldValue } = useFormikContext();

    const handleChangeValue = (event: ChangeEvent<HTMLTextAreaElement>) => {
        setFieldValue(props.name, event.target.value, !!errors[props.name]);
    };

    const wrapperClassName = classnames([styles.wrapper, styles.textarea, className]);

    return (
        <div className={wrapperClassName}>
            <textarea {...props} value={values[props.name]} className={styles.input} autoComplete="off" onChange={handleChangeValue} />
            {errors[props.name] && <span className={styles.error}>{errors[props.name]}</span>}
        </div>
    );
};

FieldArea.defaultProps = {
    className: '',
};

export const FieldPhoneNumber: FunctionComponent<InputHTMLAttributes<HTMLInputElement> & FieldProps> = ({ className, ...props }) => {
    const { values, errors, setFieldValue } = useFormikContext();

    const handleChangeValue = (event: ChangeEvent<HTMLInputElement>) => {
        setFieldValue(props.name, event.target.value, !!errors[props.name]);
    };

    const wrapperClassName = classnames([styles.wrapper, styles.phone_number, className]);

    return (
        <div className={wrapperClassName}>
            <label className={styles.field}>
                <span className={styles.region_code}>+84</span>
                <input {...props} value={values[props.name]} className={styles.input} autoComplete="off" onChange={handleChangeValue} />
            </label>
            {errors[props.name] && <span className={styles.error}>{errors[props.name]}</span>}
        </div>
    );
};

FieldPhoneNumber.defaultProps = {
    className: '',
};

export default Field;
